import { render, staticRenderFns } from "./BrandPartsGroupEditLayer.vue?vue&type=template&id=92153726&scoped=true&"
import script from "./BrandPartsGroupEditLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsGroupEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsGroupEditLayer.vue?vue&type=style&index=0&id=92153726&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92153726",
  null
  
)

export default component.exports